export default __webpack_public_path__ + "static/media/delivery.1346af3c.svg";